import React from 'react';

interface CurrencyCellProps {
  value: number | string;
  label?: string;
  bgColor?: string;
  txtColor?: string;
}

const CurrencyCell: React.FC<CurrencyCellProps> = ({ value, label, bgColor, txtColor }) => {
  let numVal = (value ? Number(value) : Number.NaN) || 0;
  let valueStr = numVal.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return (
      <div style={{
        backgroundColor: bgColor ?? 'transparent',
        color: txtColor ?? 'inherit',
        whiteSpace: 'nowrap'
      }}>
        ${valueStr}
        {label ? ` ${label}` : ''}
      </div>
  );
};

export default CurrencyCell;
